import {
    Ambulance,
    Archive,
    ArrowDown,
    ArrowDownWideNarrow,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowUp,
    ArrowUpDown,
    ArrowUpNarrowWide,
    Award,
    Ban,
    Banknote,
    Bell,
    BellOff,
    Binoculars,
    Bold,
    Book,
    Bookmark,
    Box,
    Boxes,
    Briefcase,
    Building,
    Calculator,
    Calendar,
    CalendarCheck,
    CalendarPlus,
    CalendarX,
    Camera,
    ChartArea,
    ChartColumn,
    ChartLine,
    ChartPie,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsDown,
    ChevronsUp,
    Circle,
    CircleAlert,
    CircleCheck,
    CircleDot,
    CirclePause,
    CirclePlay,
    CirclePlus,
    CircleQuestionMark,
    CircleX,
    Clipboard,
    Clock,
    Cloud,
    CloudUpload,
    Code,
    Cog,
    Columns2,
    Compass,
    Contact,
    Copy,
    CornerDownRight,
    Cpu,
    CreditCard,
    Crosshair,
    Database,
    Download,
    DraftingCompass,
    Droplet,
    EllipsisVertical,
    Eraser,
    ExternalLink,
    Eye,
    EyeOff,
    Factory,
    FastForward,
    File,
    FileArchive,
    FileImage,
    FileSpreadsheet,
    FileText,
    Files,
    Flag,
    FlagTriangleRight,
    Folder,
    FolderOpen,
    Funnel,
    Gauge,
    Gavel,
    GitBranch,
    Globe,
    Grid3x3,
    Handshake,
    Hash,
    Heading1,
    Heart,
    HeartPulse,
    Hourglass,
    House,
    IdCard,
    Image,
    Inbox,
    Info,
    Italic,
    Key,
    Keyboard,
    Landmark,
    LayoutDashboard,
    Leaf,
    LifeBuoy,
    Lightbulb,
    Link,
    Link2,
    List,
    ListChecks,
    ListIndentDecrease,
    ListIndentIncrease,
    ListOrdered,
    LoaderCircle,
    Lock,
    LogIn,
    LogOut,
    Mail,
    MailOpen,
    Map,
    MapPin,
    Maximize,
    Megaphone,
    Menu,
    MessageSquare,
    MessagesSquare,
    Minimize,
    Minus,
    Moon,
    Move,
    Network,
    Paintbrush,
    Paperclip,
    Pause,
    Pencil,
    Percent,
    Play,
    Plug,
    Plus,
    Printer,
    Quote,
    RefreshCw,
    Repeat,
    Reply,
    ReplyAll,
    Rocket,
    RotateCcwClock,
    Save,
    Scale,
    Search,
    SearchX,
    Send,
    Share2,
    Shield,
    Shuffle,
    SlidersHorizontal,
    Snowflake,
    Square,
    SquareCheck,
    SquareMinus,
    SquarePen,
    SquarePlus,
    Star,
    Stethoscope,
    StickyNote,
    Strikethrough,
    Sun,
    Table,
    Tag,
    Tags,
    Target,
    TextAlignCenter,
    TextAlignEnd,
    TextAlignJustify,
    TextAlignStart,
    Thermometer,
    ThumbsUp,
    Trash,
    TriangleAlert,
    Trophy,
    Truck,
    Type,
    Underline,
    Undo,
    Unlink,
    Upload,
    User,
    UserLock,
    UserPlus,
    UserRound,
    UserRoundCog,
    UserX,
    Users,
    Video,
    WandSparkles,
    Wrench,
    X,
    Zap,
    ZoomIn,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** Every icon the interface can draw. One import per icon, so the bundler drops
 *  the ones no screen reaches. */
const REGISTRY: Record<string, LucideIcon> = {
    "fa-address-book-o": Contact,
    "fa-align-center": TextAlignCenter,
    "fa-align-justify": TextAlignJustify,
    "fa-align-left": TextAlignStart,
    "fa-align-right": TextAlignEnd,
    "fa-ambulance": Ambulance,
    "fa-angle-double-down": ChevronsDown,
    "fa-angle-double-up": ChevronsUp,
    "fa-angle-down": ChevronDown,
    "fa-angle-left": ChevronLeft,
    "fa-angle-right": ChevronRight,
    "fa-angle-up": ChevronUp,
    "fa-archive": Archive,
    "fa-area-chart": ChartArea,
    "fa-arrow-down": ArrowDown,
    "fa-arrow-left": ArrowLeft,
    "fa-arrow-right": ArrowRight,
    "fa-arrow-up": ArrowUp,
    "fa-arrows-alt": Move,
    "fa-arrows-v": ArrowUpDown,
    "fa-balance-scale": Scale,
    "fa-ban": Ban,
    "fa-bar-chart": ChartColumn,
    "fa-bars": Menu,
    "fa-bell": Bell,
    "fa-bell-slash": BellOff,
    "fa-binoculars": Binoculars,
    "fa-bold": Bold,
    "fa-bolt": Zap,
    "fa-book": Book,
    "fa-bookmark": Bookmark,
    "fa-bookmark-o": Bookmark,
    "fa-briefcase": Briefcase,
    "fa-building": Building,
    "fa-building-o": Building,
    "fa-bullhorn": Megaphone,
    "fa-bullseye": Target,
    "fa-calculator": Calculator,
    "fa-calendar": Calendar,
    "fa-calendar-check-o": CalendarCheck,
    "fa-calendar-o": Calendar,
    "fa-calendar-plus-o": CalendarPlus,
    "fa-calendar-times-o": CalendarX,
    "fa-camera": Camera,
    "fa-caret-down": ChevronDown,
    "fa-caret-right": ChevronRight,
    "fa-certificate": Award,
    "fa-chain-broken": Unlink,
    "fa-check": Check,
    "fa-check-circle": CircleCheck,
    "fa-check-circle-o": CircleCheck,
    "fa-check-square": SquareCheck,
    "fa-check-square-o": SquareCheck,
    "fa-chevron-down": ChevronDown,
    "fa-chevron-left": ChevronLeft,
    "fa-chevron-right": ChevronRight,
    "fa-chevron-up": ChevronUp,
    "fa-circle": Circle,
    "fa-circle-o": Circle,
    "fa-circle-o-notch": LoaderCircle,
    "fa-clipboard": Clipboard,
    "fa-clock-o": Clock,
    "fa-clone": Copy,
    "fa-cloud": Cloud,
    "fa-cloud-upload": CloudUpload,
    "fa-code": Code,
    "fa-code-fork": GitBranch,
    "fa-cog": Cog,
    "fa-columns": Columns2,
    "fa-comment-o": MessageSquare,
    "fa-comments": MessagesSquare,
    "fa-comments-o": MessagesSquare,
    "fa-compass": Compass,
    "fa-compress": Minimize,
    "fa-credit-card": CreditCard,
    "fa-crosshairs": Crosshair,
    "fa-cube": Box,
    "fa-cubes": Boxes,
    "fa-dashboard": LayoutDashboard,
    "fa-database": Database,
    "fa-dot-circle-o": CircleDot,
    "fa-download": Download,
    "fa-drafting-compass": DraftingCompass,
    "fa-edit": Pencil,
    "fa-envelope": Mail,
    "fa-envelope-o": Mail,
    "fa-envelope-open-o": MailOpen,
    "fa-ellipsis-v": EllipsisVertical,
    "fa-eraser": Eraser,
    "fa-exchange": ArrowLeftRight,
    "fa-exclamation": Circle,
    "fa-exclamation-circle": CircleAlert,
    "fa-exclamation-triangle": TriangleAlert,
    "fa-expand": Maximize,
    "fa-external-link": ExternalLink,
    "fa-eye": Eye,
    "fa-eye-slash": EyeOff,
    "fa-file-archive-o": FileArchive,
    "fa-file-excel-o": FileSpreadsheet,
    "fa-file-image-o": FileImage,
    "fa-file-o": File,
    "fa-file-pdf-o": FileText,
    "fa-file-text-o": FileText,
    "fa-files-o": Files,
    "fa-filter": Funnel,
    "fa-flag": Flag,
    "fa-flag-checkered": FlagTriangleRight,
    "fa-flag-o": Flag,
    "fa-floppy-o": Save,
    "fa-folder": Folder,
    "fa-folder-o": Folder,
    "fa-folder-open": FolderOpen,
    "fa-folder-open-o": FolderOpen,
    "fa-font": Type,
    "fa-forward": FastForward,
    "fa-gavel": Gavel,
    "fa-globe": Globe,
    "fa-handshake-o": Handshake,
    "fa-hashtag": Hash,
    "fa-header": Heading1,
    "fa-heart-o": Heart,
    "fa-heartbeat": HeartPulse,
    "fa-history": RotateCcwClock,
    "fa-home": House,
    "fa-hourglass-half": Hourglass,
    "fa-hourglass-o": Hourglass,
    "fa-id-badge": IdCard,
    "fa-id-card": Contact,
    "fa-id-card-o": IdCard,
    "fa-image": Image,
    "fa-inbox": Inbox,
    "fa-indent": ListIndentIncrease,
    "fa-industry": Factory,
    "fa-info-circle": Info,
    "fa-italic": Italic,
    "fa-key": Key,
    "fa-keyboard-o": Keyboard,
    "fa-leaf": Leaf,
    "fa-level-down": CornerDownRight,
    "fa-life-ring": LifeBuoy,
    "fa-lightbulb-o": Lightbulb,
    "fa-line-chart": ChartLine,
    "fa-link": Link,
    "fa-list": List,
    "fa-list-alt": ListChecks,
    "fa-list-ol": ListOrdered,
    "fa-list-ul": List,
    "fa-lock": Lock,
    "fa-long-arrow-left": ArrowLeft,
    "fa-long-arrow-right": ArrowRight,
    "fa-magic": WandSparkles,
    "fa-map-marker": MapPin,
    "fa-map-o": Map,
    "fa-microchip": Cpu,
    "fa-minus": Minus,
    "fa-minus-square-o": SquareMinus,
    "fa-money": Banknote,
    "fa-moon-o": Moon,
    "fa-object-group": Boxes,
    "fa-outdent": ListIndentDecrease,
    "fa-paint-brush": Paintbrush,
    "fa-paper-plane": Send,
    "fa-paper-plane-o": Send,
    "fa-paperclip": Paperclip,
    "fa-pause": Pause,
    "fa-pause-circle": CirclePause,
    "fa-pencil": Pencil,
    "fa-pencil-square-o": SquarePen,
    "fa-percent": Percent,
    "fa-picture-o": Image,
    "fa-pie-chart": ChartPie,
    "fa-play": Play,
    "fa-play-circle": CirclePlay,
    "fa-plug": Plug,
    "fa-plus": Plus,
    "fa-plus-circle": CirclePlus,
    "fa-plus-square": SquarePlus,
    "fa-plus-square-o": SquarePlus,
    "fa-print": Printer,
    "fa-question-circle": CircleQuestionMark,
    "fa-question-circle-o": CircleQuestionMark,
    "fa-quote-right": Quote,
    "fa-random": Shuffle,
    "fa-refresh": RefreshCw,
    "fa-repeat": Repeat,
    "fa-reply": Reply,
    "fa-reply-all": ReplyAll,
    "fa-rocket": Rocket,
    "fa-save": Save,
    "fa-search": Search,
    "fa-search-minus": SearchX,
    "fa-search-plus": ZoomIn,
    "fa-send-o": Send,
    "fa-share": Share2,
    "fa-share-alt": Share2,
    "fa-share-alt-square": Share2,
    "fa-shield": Shield,
    "fa-sign-in": LogIn,
    "fa-sign-out": LogOut,
    "fa-sitemap": Network,
    "fa-sliders": SlidersHorizontal,
    "fa-snowflake-o": Snowflake,
    "fa-sort": ArrowUpDown,
    "fa-sort-down": ArrowDownWideNarrow,
    "fa-sort-up": ArrowUpNarrowWide,
    "fa-spinner": LoaderCircle,
    "fa-square-o": Square,
    "fa-star": Star,
    "fa-star-o": Star,
    "fa-stethoscope": Stethoscope,
    "fa-sticky-note-o": StickyNote,
    "fa-stop": Square,
    "fa-strikethrough": Strikethrough,
    "fa-sun-o": Sun,
    "fa-table": Table,
    "fa-tachometer": Gauge,
    "fa-tag": Tag,
    "fa-tags": Tags,
    "fa-tasks": ListChecks,
    "fa-th": Grid3x3,
    "fa-th-large": Grid3x3,
    "fa-th-list": Menu,
    "fa-thermometer-half": Thermometer,
    "fa-thumbs-up": ThumbsUp,
    "fa-times": X,
    "fa-times-circle": CircleX,
    "fa-tint": Droplet,
    "fa-trash": Trash,
    "fa-trash-o": Trash,
    "fa-trophy": Trophy,
    "fa-truck": Truck,
    "fa-underline": Underline,
    "fa-undo": Undo,
    "fa-university": Landmark,
    "fa-unlink": Link2,
    "fa-upload": Upload,
    "fa-user": User,
    "fa-user-circle": UserRound,
    "fa-user-circle-o": UserRound,
    "fa-user-md": UserRoundCog,
    "fa-user-o": User,
    "fa-user-plus": UserPlus,
    "fa-user-secret": UserLock,
    "fa-user-times": UserX,
    "fa-users": Users,
    "fa-video-camera": Video,
    "fa-window-maximize": Maximize,
    "fa-wrench": Wrench,
};

/** Icons that point in one direction, so they must mirror under `dir="rtl"`. */
const MIRRORED = new Set<string>([
    "fa-angle-left",
    "fa-angle-right",
    "fa-chevron-left",
    "fa-chevron-right",
    "fa-arrow-left",
    "fa-arrow-right",
    "fa-long-arrow-left",
    "fa-long-arrow-right",
    "fa-caret-right",
    "fa-indent",
    "fa-outdent",
    "fa-level-down",
    "fa-share",
    "fa-share-alt",
    "fa-share-alt-square",
    "fa-sign-in",
    "fa-sign-out",
    "fa-external-link",
    "fa-undo",
    "fa-reply",
    "fa-reply-all",
    "fa-align-left",
    "fa-align-right",
    "fa-list-ul",
    "fa-list-ol",
    "fa-sort-up",
    "fa-sort-down",
    "fa-exchange",
    "fa-paper-plane",
    "fa-paper-plane-o",
    "fa-send-o",
    "fa-random",
]);

/** Drawn when we are handed a name we never registered, so a missing icon
 *  shows up as a hollow circle instead of vanishing. */
const FALLBACK: LucideIcon = REGISTRY["fa-circle-o"] as LucideIcon;

/** The class that asks for a turn rather than naming an icon. */
const SPIN = "fa-spin";

interface Resolved {
    Glyph: LucideIcon;
    spin: boolean;
    mirror: boolean;
    slug: string;
    carried: string[];
}

/** The icon a class stands for, read the way `Font Awesome` read a class list.
 *
 *  A bare class such as `fa-home` names the icon. A class list such as
 *  `fa-spinner fa-spin` names the icon and asks for the turn, and
 *  `fa-caret-right mk-table-groupcaret-closed` names the icon and carries
 *  styling. Reading the whole list is what let every screen keep the strings
 *  it already had and change only how it draws them.
 *
 *  An unknown class draws the fallback rather than nothing, so a gap is
 *  visible instead of silent. */
function resolveIcon(name?: string | null): Resolved {
    const parts = (name || "").trim().split(/\s+/).filter(Boolean);
    const glyph = parts.find((part) => REGISTRY[part]) || "";
    return {
        Glyph: (glyph && REGISTRY[glyph]) || FALLBACK,
        spin: parts.includes(SPIN),
        mirror: MIRRORED.has(glyph),
        /** the class the icon was asked for, so a stylesheet can still single
         *  one icon out with `.mk-icon-fa-search`. */
        slug: glyph,
        /** Anything else in the string is styling that came with the icon,
         *  such as `fa-caret-right mk-table-groupcaret-closed`. It is kept
         *  rather than dropped, so a screen can still colour one icon alone. */
        carried: parts.filter((part) => part !== glyph && part !== SPIN && part !== "fa"
                                      && !part.startsWith("fa-")),
    };
}

interface Props {
    /** the icon class, such as `fa-home`, or a list such as `fa-spinner fa-spin`. */
    name?: string | null;
    /** any length, or any css size. Defaults to the text size, so an icon
     *  follows its label exactly as the old glyph did. */
    size?: string | number;
    className?: string;
    strokeWidth?: string | number;
    /** a tooltip. It makes the icon reachable on its own, so it is only read
     *  aloud when the reader would otherwise have nothing to name. */
    title?: string;
}

/** One icon, drawn from the registry. Its colour is the colour of the text
 *  around it, so an icon never carries a colour of its own. */
export function MkIcon({ name, size = "1em", className, strokeWidth, title }: Props) {
    const { Glyph, spin, mirror, slug, carried } = resolveIcon(name);
    const classes = ["mk-icon", slug ? `mk-icon-${slug}` : "",
                     mirror ? "mk-icon-mirror" : "",
                     spin ? "mk-icon-spin" : "", ...carried, className ?? ""]
        .filter(Boolean).join(" ");
    return <Glyph className={classes} size={size} strokeWidth={strokeWidth}
                  role={title ? "img" : undefined}
                  aria-hidden={title ? undefined : "true"}
                  aria-label={title}
                  focusable="false">{title ? <title>{title}</title> : null}</Glyph>;
}
